document.addEventListener('DOMContentLoaded', ()=>{

    function removeProductItem(){

        const marrakechLinks = document.querySelectorAll('a[href*="marrakech-component"]');

        marrakechLinks.forEach(link => {
            const productItem = link.closest('.product-item');

            if(productItem){
                productItem.remove();
            }
        });
    }

    removeProductItem();

    const observer = new MutationObserver(removeProductItem);
    observer.observe(document.body,{childList: true, subtree:true})
});




